import { Form, Input } from "antd";
import { requiredField } from "../common/common";
import SimpleFormPage from "../common/SimpleFormPage";

export default function NewAbsenceType() {
  return (
    <SimpleFormPage title="Nuova categoria assenza">
      <Form.Item
        label="ID"
        name="id"
        rules={[requiredField, { whitespace: true, message: "Campo obbligatorio" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="Nome" name="name">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
